// WOD (Workout of the Day) Types

export type ScoreType = 'time' | 'reps' | 'weight' | 'rounds';

export interface WOD {
    id: string;
    businessId: string;
    title: string;           // "FRAN", "Murph", etc.
    date: string;            // "2026-01-01" (YYYY-MM-DD)
    description: string;     // Descripción del entreno
    scoreType: ScoreType;    // Tipo de puntuación
    isActive: boolean;
    createdBy: string;       // Admin ID
    createdAt: Date;
    updatedAt?: Date;
}

export interface WODResult {
    id: string;
    wodId: string;
    businessId: string;
    userId: string;
    userName: string;        // Para mostrar en leaderboard sin query extra
    userPhotoUrl?: string;   // Foto de perfil opcional
    score: number;           // Valor numérico (segundos, reps, kg, rondas)
    scoreDisplay: string;    // "5:23" o "150 reps" - formato legible
    notes?: string;          // Comentarios del usuario ("RX", "Scaled", etc.)
    createdAt: Date;
}

// Helper para formatear scores según tipo
export const formatScore = (score: number, type: ScoreType): string => {
    switch (type) {
        case 'time':
            const mins = Math.floor(score / 60);
            const secs = score % 60;
            return `${mins}:${secs.toString().padStart(2, '0')}`;
        case 'reps':
            return `${score} reps`;
        case 'weight':
            return `${score} kg`;
        case 'rounds':
            return `${score} rondas`;
        default:
            return score.toString();
    }
};

// Helper para parsear tiempo "MM:SS" a segundos
export const parseTimeToSeconds = (timeStr: string): number => {
    const parts = timeStr.split(':');
    if (parts.length === 2) {
        const mins = parseInt(parts[0], 10) || 0;
        const secs = parseInt(parts[1], 10) || 0;
        return mins * 60 + secs;
    }
    return parseInt(timeStr, 10) || 0;
};

// Nombre legible del tipo de score
export const getScoreTypeName = (type: ScoreType): string => {
    switch (type) {
        case 'time': return 'Tiempo (menor mejor)';
        case 'reps': return 'Repeticiones (mayor mejor)';
        case 'weight': return 'Peso (mayor mejor)';
        case 'rounds': return 'Rondas (mayor mejor)';
        default: return type;
    }
};
